'use client';

import React from 'react';

interface HTMLRendererProps {
  html: string;
}

const HTMLRenderer: React.FC<HTMLRendererProps> = ({ html }) => {
  // The 'html' prop is expected to be a string of raw HTML.
  // dangerouslySetInnerHTML will render it.
  // It is crucial to ensure that the HTML content is sanitized before being stored
  // in the database to prevent cross-site scripting (XSS) vulnerabilities.
  return <div className="prose dark:prose-invert" dangerouslySetInnerHTML={{ __html: html || '' }} />;
};

export default HTMLRenderer;
